import React from 'react';
import FavoriteIcon from './favorite-icon';
import OpenHours from './open-hours';
import AddressLink from './address-link';
import BookTicketsButton from './book-tickets-button';

var PlaceThumbnail = React.createClass({

  render: function(){
    var item = this.props.item;

    item.bucket = item.bucket || "places"
    if (item.bucket === 'places'){
      var imgName = this.props.isSmallScreen ? 'thumb-480.jpg' : 'thumb-302.jpg';
    } else {
      var imgName = 'thumb-md.jpg'
    }

    var openHours = (this.props.weekday) ? <OpenHours weekday={this.props.weekday} hours={item.weekday_hours} /> : null,
        itemHref = (item.bucket === "guides") ? ("/" + item.destination + "/guide") : ("/" + item.destination + "/attraction/" + item.slug + '/' + item.id);

    // on small screen, the caption is shown on top of image, hence
    // needs darker background. Others don't need darker background
    var thumbnailNotDarker = (this.props.isSmallScreen) ? '' : 'not-dark',
        bookTickets = <BookTicketsButton item={item} />;
    
    if (!!item.photo && item.photo.src === "Google"){
      var imgUrl = "/api/images/dynamic/google/" + item.googleplaces_id
      // var imgUrl = "/api/images/google/" + item.photo.url + "/thumb";
    } else if (item.photo_source === "Google") {
      var imgUrl = "/api/images/dynamic/google/" + item.googleplaces_id
      // var imgUrl = "/api/images/google/" + item.photo_ref + "/thumb";
    } else {
      if (!!item.photo || this.props.autoImageUrls){
        var imgUrl = "/api/images/dynamic/google/" + item.googleplaces_id
        // var imgUrl = "http://media.ruebarue.com/photos/" + item.bucket + "/" + item.id + '/' + imgName;
      } else {
        var imgUrl = null;
      }
    }

    if (imgUrl === null) return null;

    return (
      <div className="col-sm-4 sidebar place-thumbnail">
        <div className="widget">
          <div className="img-holder">
            <div className="place-img" style={{ backgroundImage: "url(" + imgUrl + ")", content: "url(" + imgUrl + ")" }}>
              <a href={ itemHref } className="thumb">
                <FavoriteIcon placeId={item.id} />
                <div className={"caption " + thumbnailNotDarker}>
                  <div className="caption-holder">
                    <div className={"marker-pin day_" + this.props.groupIndex }>{ this.props.itemIndex }</div>
                    <p className="place-hrs">{item.from} - {item.to}</p> 
                    <p className="place-name">{ item.name }</p>
                  </div>
                </div>
              </a>
            </div>
          </div>
          {/* <AddressLink item={item} isSmallScreen={this.props.isSmallScreen} dayIndex={this.props.groupIndex} /> */}
        {openHours}
        {bookTickets} 
      </div>
      </div>
    );
  }
});

module.exports = PlaceThumbnail;



// WEBPACK FOOTER //
// ./components/place-thumbnail.js